import { Dinero, multiply } from "dinero.js"
import { DateTimeFactory } from "../../../../../modules/localization/useDateTime"

type DateRange = { start: string; end: string } | null

export function formattedMeetingTimeRange(
    dateTimeFactory: DateTimeFactory,
    start?: string | null,
    end?: string | null,
): string {
    if (!start || !end) return ""

    const startDateTime = dateTimeFactory.fromApi(start)
    const endDateTime = dateTimeFactory.fromApi(end)

    return dateTimeFactory.formatPeriod(startDateTime, endDateTime)
}

function hasTimePart(value: string): boolean {
    return /\d{2}:\d{2}/.test(value)
}

export function formatDeliveryDateForReceipt(
    dateTimeFactory: DateTimeFactory,
    {
        deliveryDateValue,
        firstDeliveryTimeValue,
    }: Readonly<{
        deliveryDateValue: string | null
        firstDeliveryTimeValue: string | null
    }>,
): string | null {
    if (!deliveryDateValue) return null

    const deliveryDateTimeValue = hasTimePart(deliveryDateValue)
        ? deliveryDateValue
        : firstDeliveryTimeValue
          ? `${deliveryDateValue} ${firstDeliveryTimeValue}`
          : deliveryDateValue

    const dt = dateTimeFactory.fromApi(deliveryDateTimeValue)
    if (!dt.isValid) return null

    return hasTimePart(deliveryDateTimeValue) ? dateTimeFactory.formatDateTime(dt) : dateTimeFactory.formatDate(dt)
}

export function calculateVATDinero(total: Dinero<number>, vatRate: number, priceIncludesVat: boolean) {
    // When price includes VAT: extract VAT component using vatRate / (100 + vatRate)
    // When price excludes VAT: calculate VAT using vatRate / 100
    const vatRatio = priceIncludesVat ? vatRate / (100 + vatRate) : vatRate / 100
    const [integer, decimals = ""] = vatRatio.toString().split(".")

    const ratio = {
        amount: parseInt(integer + decimals, 10),
        scale: decimals.length,
    }

    return multiply(total, ratio)
}
